<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-flex="10"></md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>Enquiry Form</h2>
            <md-layout md-flex="45"></md-layout>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Client Name</label>

              <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName" v-model="salesList.clientName"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Contact Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="clientContact"
                name="clientContact"
                v-model="salesList.contactNumber"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="40"></md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Client Address</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="	clientAddress"
                name="	clientAddress"
                v-model="salesList.corporateAddress"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-border">
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <h4>
            Job Type :
            <span
              class="error"
            >{{ (JobType.filter((x)=> x==true).length == 0) ? JobTypeError : ''}}</span>
          </h4>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout
            v-for="(showJobTypeVal, index) in showJobType"
            :key="index"
            :md-flex="showJobTypeVal.flex"
          >
            <md-checkbox
              v-model="JobType[index]"
              @change="JobTypeVal(index,showJobTypeVal.value)"
              class="md-primary"
              :md-value="showJobTypeVal.value"
              :name="'JobType'+(index+1)"
              :id="'JobType'+(index+1)"
              :disabled="permissionStatus?true:checkIsContract"
            >{{showJobTypeVal.show}}</md-checkbox>
          </md-layout>
        </md-layout>
        <hr class="hr-border">

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label for="type">Transport Type</label>
            <model-list-select
              :list="transportTypeList"
              v-model="salesList.type"
              :disabled="permissionStatus?true:checkIsContract"
              option-value="transportTypeVal"
              option-text="transportTypeText"
              placeholder="Select Transport Type"
            ></model-list-select>
            <span class="error" v-if="!salesList.type">{{typeError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label for="AutoPickupLocation">Pickup Location</label>

            <model-list-select
              :list="masterList"
              v-model="AutoPickupLocation"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Pickup Location"
            ></model-list-select>

            <span class="error" v-if="!salesList.fromLocation">{{fromLocationError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label for="AutoStuffingLocation">Stuffing Location</label>

            <model-list-select
              :list="masterList"
              v-model="AutoStuffingLocation"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Stuffing Location"
            ></model-list-select>

            <span class="error" v-if="!salesList.StuffingLocation">{{StuffingLocationError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label for="AutoHandoverLocation">Handover Location</label>

            <model-list-select
              :list="masterList"
              v-model="AutoHandoverLocation"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Handover Location"
            ></model-list-select>

            <span class="error" v-if="!salesList.toLocation">{{toLocationError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label for="AutoContainerType">Container Type</label>

            <model-list-select
              :list="containerTypeList"
              v-model="AutoContainerType"
              option-value="containerTypeId"
              option-text="containerType"
              placeholder="Select Container Type"
            ></model-list-select>
          </md-layout>

          <md-layout
            md-flex="70"
            v-if="salesList.multipleContainerType.length>0"
            style="margin-top:30px"
          >
            <md-chip
              md-deletable
              v-for="(type,index) in salesList.multipleContainerType"
              :key="index"
              @delete="deleteContainer(type)"
            >{{type}}</md-chip>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="45">
            <md-layout md-flex="100">
              <label>Transportation Goods Details</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="transportDetail"
                name="transportDetail"
                v-model="salesList.transportDetail"
                :disabled="permissionStatus?true:checkIsContract"
              ></b-form-textarea>
            </md-layout>
            <span class="error" v-if="!salesList.transportDetail">{{transportDetailError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="40">
            <md-layout md-flex="100">
              <label>Other Details</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="otherDetail"
                name="otherDetail"
                v-model="salesList.otherDetail"
                :disabled="permissionStatus?true:checkIsContract"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Comments</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="comment"
                name="comment"
                v-model="salesList.comment"
                :disabled="permissionStatus?true:checkIsContract"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
        </md-layout>

        <hr class="hr-s">
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <h4>Cost Calculator :</h4>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="75"></md-layout>
          <md-layout md-flex="20">
            <date-picker
            :format="selectDateFormat"
              lang="en"
              v-model="salesList.salesBookingDate"
              :disabled="permissionStatus?true:checkIsContract"
              placeholder="Enquiry date"
            ></date-picker>
            <span class="error" v-if="!salesList.salesBookingDate">{{dateError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Driver Expense Per Day</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="driverExpense"
                name="driverExpense"
                v-model="salesList.driverExpense"
                @keyup="finalbasecost()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.driverExpense">{{driverExpenseError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>Truck average(in km)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="truckAverage"
                name="truckAverage"
                @keyup="finalbasecost()"
                v-model="salesList.truckAverage"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.truckAverage">{{truckAverageError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>Distance(in km)</label>
              <b-form-input :formatter="capitalizeAll"
                id="distance"
                type="number"
                min="0"
                name="distance"
                v-model="salesList.distance"
                @keyup="finalbasecost()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.distance">{{distanceError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="10">
            <md-layout md-flex="100">
              <label>No of days</label>
              <b-form-input :formatter="capitalizeAll"
                id="noOffDay"
                name="noOffDay"
                type="number"
                min="0"
                v-model="salesList.noOffDay"
                @keyup="finalbasecost()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.noOffDay">{{noOffDayError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>Toll Prices(in Rs)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="tollPrice"
                name="tollPrice"
                v-model="salesList.tollPrice"
                @keyup="finalbasecost()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.tollPrice">{{tollPriceError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>Diesel Rate(in Rs.)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="dieselRate"
                name="dieselRate"
                v-model="salesList.dieselRate"
                @keyup="finalbasecost()"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.dieselRate">{{dieselRateError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Base Cost</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="baseCost"
                name="baseCost"
                v-model="salesList.baseCost"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.baseCost">{{baseCostError}}</span>
          </md-layout>

          <md-layout md-flex="10"></md-layout>
          <md-layout md-flex="10">
            <md-layout md-flex="100">
              <label>Margin(in %)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="quotemargin"
                @keyup="finalbasecost()"
                name="quotemargin"
                v-model="salesList.quotemargin"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.quotemargin">{{quotemarginError}}</span>
          </md-layout>

          <md-layout md-flex="20"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Sales Rate</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="quoteSalesCost"
                name="quoteSalesCost"
                v-model="salesList.quoteSalesCost"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!salesList.quoteSalesCost">{{quoteSalesCostError}}</span>
          </md-layout>
        </md-layout>
        <hr class="hr-border">
        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="40"></md-layout>

          <md-layout md-flex="30">
            <md-button
              class="md-raised md-primary md-button-color"
              :disabled="permissionStatus?true:checkIsContract"
              @click="showQuotation"
              id="addButtonLoader"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
        </md-layout>
      </md-card-content>
    </md-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert1.content1" :md-ok-text="alert1.ok1" ref="addPop1"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/sales/leads");

      this.getClientList();
      this.fetchContainer();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      transportTypeList: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export"
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import"
        },
        {
          transportTypeVal: "Empty_Moment",
          transportTypeText: "Empty Moment"
        }
      ],
      AutoPickupLocation: {},
      AutoStuffingLocation: {},
      AutoHandoverLocation: {},
      AutoContainerType: {},
      containerTypeDetail: ["dsfds"],
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      alert: {
        content: "a",
        ok: "ok"
      },
      alert1: {
        content1: "a",
        ok1: "ok"
      },
      salesList: {
        enquiryId: "",
        clientName: "",
        contactNumber: "",
        corporateAddress: "",
        noofTruck: "",
        jobType: [],
        salesBookingDate: "",
        fromLocation: "",
        toLocation: "",
        StuffingLocation: "",
        containerType: "",
        type: "",
        status: "",
        transportDetail: "",
        otherDetail: "",
        comment: "",
        baseCost: "",
        dieselRate: "",
        distance: "",
        driverExpense: "500",
        noOffDay: "",

        tollPrice: "",
        truckAverage: "3.5",
        quotemargin: "100",
        quoteSalesCost: "",
        fromlocationId: "",
        tolocationId: "",
        stuffinglocationId: "",
        multipleContainerType: [],
        multipleContainerTypeId: []
      },

      driverExpenseError: "",
      baseCostError: "",
      dieselRateError: "",
      tollPriceError: "",
      noOffDayError: "",
      distanceError: "",
      quoteSalesCostError: "",
      containerTypeDetail: [],
      viewAllQuotation: [],
      assignListArray: [],
      JobType: [],
      showJobType: [],
      clientNameError: "",
      billingPartyNameError: "",
      toLocationError: "",
      JobTypeError: "",
      typeError: "",
      dateError: "",
      fromLocationError: "",
      transportDetailError: "",
      StuffingLocationError: "",
      doValidityError: "",
      billingPartyName: "",
      validate: true,
      checkIsContract: false,

      getCLientData: [
        {
          clientId: "2",
          clientName: "Saif",
          companyType: "privateLimited",
          corporateAddress: "gdfg"
        }
      ],
      getLocationData: [
        {
          pickupId: "2",
          pickupLocation: "Saif",
          pickupIsActive: "privateLimited"
        }
      ]
    };
  },

  mounted() {
    this.JqueryFun();
    this.getData();
  },
  beforeDestroy() {
    this.$sessionsStorage.set("setEnquiryBookingId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect
  },
  computed: {
    masterList() {
      return this.getLocationData;
    },
    containerTypeList() {
      return this.containerTypeDetail;
    }
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  watch: {
    AutoPickupLocation: {
      handler: function(newVal, oldVal) {
        this.masterCallback2(newVal);
      },
      deep: true
    },

    AutoHandoverLocation: {
      handler: function(newVal, oldVal) {
        this.masterCallback1(newVal);
      },
      deep: true
    },

    AutoStuffingLocation: {
      handler: function(newVal, oldVal) {
        this.masterCallback3(newVal);
      },
      deep: true
    },
    AutoContainerType: {
      handler: function(newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true
    }
  },
  methods: {
    validateSalesBookingForm() {
      let validate_new = true;

      if (this.salesList.driverExpense == "") {
        $("#driverExpense").focus();
        this.driverExpenseError = "Enter your expenses";
        validate_new = false;
      }

      if (this.salesList.truckAverage == "") {
        $("#truckAverage").focus();
        this.truckAverageError = "Enter your truck average";
        validate_new = false;
      }
      if (this.salesList.noOffDay == "") {
        $("#noOffDay").focus();
        this.noOffDayError = "Enter your no of day";
        validate_new = false;
      }
      if (this.salesList.distance == "") {
        $("#distance").focus();
        this.distanceError = "Enter your distance";
        validate_new = false;
      }
      if (this.salesList.dieselRate == "") {
        $("#dieselRate").focus();
        this.dieselRateError = "Enter your diesel rate";
        validate_new = false;
      }
      if (this.salesList.tollPrice == "") {
        $("#tollPrice").focus();
        this.tollPriceError = "Enter your toll price";
        validate_new = false;
      }
      if (this.salesList.quotemargin == "") {
        $("#quotemargin").focus();
        this.quotemarginError = "Enter your margin";
        validate_new = false;
      }
      if (this.salesList.quoteSalesCost == "") {
        $("#quoteSalesCost").focus();
        this.quoteSalesCostError = "Enter your sales cost";

        validate_new = false;
      }

      if (this.salesList.toLocation == "") {
        $("#toLocation").focus();
        this.toLocationError = "Enter your Location";
        validate_new = false;
      }

      if (this.salesList.fromLocation == "") {
        $("#fromLocation").focus();
        this.fromLocationError = "Enter your  Location";
        validate_new = false;
      }

      if (this.salesList.StuffingLocation == "") {
        $("#StuffingLocation").focus();
        this.StuffingLocationError = "Enter your Stuffing Location";
        validate_new = false;
      }
      if (this.JobType.filter(x => x == true).length <= 0) {
        $("#JobType1").focus();
        this.JobTypeError = "Select atleast one Job Type ";
        validate_new = false;
      }

      if (this.salesList.salesBookingDate == "") {
        $("#date").focus();
        this.dateError = "Select Date";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    fetchContainer() {
      let vehicle_drive = {
        container: "container"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/fetchContainerType_Sales.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.containerTypeDetail = data.containerDetail;
          }
        })
        .catch(error => {});
    },

    masterFilter(list, query) {
      return this.getLocationData.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },

    masterCallback1(item) {
      this.salesList.tolocationId = item.pickupId;
      this.salesList.toLocation = item.pickupLocation;
      this.distanceToll();
    },
    masterCallback2(item) {
      this.salesList.fromLocation = item.pickupLocation;
      this.salesList.fromlocationId = item.pickupId;
    },
    masterCallback3(item) {
      this.salesList.stuffinglocationId = item.pickupId;
      this.salesList.StuffingLocation = item.pickupLocation;
    },
    masterCallbackContainer(item) {
      if (this.salesList.multipleContainerType.length > 0) {
        let i = this.salesList.multipleContainerType.indexOf(
          item.containerType
        );

        if (i < 0) {
          this.salesList.multipleContainerType.push(item.containerType);
          this.salesList.multipleContainerTypeId.push(item.containerTypeId);
        }
      } else {
        this.salesList.multipleContainerType.push(item.containerType);
        this.salesList.multipleContainerTypeId.push(item.containerTypeId);
      }
      this.salesList.containerType = "";
    },
    deleteContainer(item) {
      let i = this.salesList.multipleContainerType.indexOf(item);

      this.salesList.multipleContainerType.splice(i, 1);
      this.salesList.multipleContainerTypeId.splice(i, 1);
    },
    JqueryFun() {},

    JobTypeVal(index, value) {
      value == "All" && index == 4
        ? this.JobType[index] == true
          ? (this.JobType = Array(this.showJobType.length).fill(false))
          : (this.JobType = Array(this.showJobType.length).fill(true))
        : this.JobTypeVal[index] == true;
    },

    previousSalesView() {
      this.$router.push({
        path: "/view/Enquiry"
      });
    },
    viewEnquiryDetail() {
      let sales_booking = {
        allView: "allView",
        enquiryId: this.$sessionsStorage.get("setEnquiryBookingId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/viewEnquiryBookingList.php`,
        data: JSON.stringify(sales_booking),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.JqueryFun();

            Object.keys(data.enquiryList[0]).map(x => {
              if (x == "jobType") {
                this.salesList[x] = data.enquiryList[0][x].split(",");
              } else {
                this.salesList[x] = data.enquiryList[0][x] || "";
              }
            });

            this.AutoPickupLocation = this.getLocationData.filter(x => {
              return x.pickupId == this.salesList.fromlocationId;
            })[0];

            this.AutoHandoverLocation = this.getLocationData.filter(x => {
              return x.pickupId == this.salesList.tolocationId;
            })[0];

            this.AutoStuffingLocation = this.getLocationData.filter(x => {
              return x.pickupId == this.salesList.stuffinglocationId;
            })[0];
            this.showJobType.map((x, index) => {
              let i = this.salesList.jobType.indexOf(x.value);
              i >= 0
                ? (this.JobType[index] = true)
                : (this.JobType[index] = false);
            });
          }
        })
        .catch(error => {});
    },

    onClose(type) {
      if (globalPermissionStatus("QuotationAssignment") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("QuotationAssignment")
        );
        if (type != "cancel" || type != "ok") {
          this.$router.push({
            path: "/view/Enquiry"
          });
        }
      } else {
        alert("You Dont have permision for Quotation page");
      }
    },
    showQuotation() {
      this.validateSalesBookingForm();

      if (this.validate != false) {
        let newJObTypeVal = [];
        this.showJobType.map((x, index) => {
          if (this.JobType[index] == true) {
            newJObTypeVal.push(x.value);
          }
        });
        this.salesList["newjobType"] = newJObTypeVal;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addEnquiryBooking.php`,
          data: JSON.stringify(this.salesList),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              data.salesBookingId != "" &&
              
              status == 200
            ) {
              if (data.msg == "Succesfully Inserted") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated  Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");

              this.$refs["addPop"].open();
            }
          })
          .catch(error => {});
      }
    },

    getData() {
      this.showJobType = [
        {
          value: "FF",
          show: "FF",
          flex: "10"
        },
        {
          value: "CC",
          show: "CC",
          flex: "10"
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15"
        },

        {
          value: "Yard",
          show: "Yard",
          flex: "10"
        },
        {
          value: "All",
          show: "All",
          flex: "10"
        }
      ];
      this.JobType = Array(this.showJobType.length).fill(false);
    },

    distanceToll() {
      let new_data = {};
      if (
        this.salesList.fromlocationId != "" &&
        this.salesList.tolocationId != ""
      ) {
        let storeMaster = this.$store.getters.storeMasterList;
        let getfromLatLong = storeMaster.filter(y => {
          return (
            y.pickupId == this.salesList.fromlocationId &&
            y.latitude != null &&
            y.longitude != null
          );
        });

        let gettoLatLong = storeMaster.filter(y => {
          return (
            y.pickupId == this.salesList.tolocationId &&
            y.latitude != null &&
            y.longitude != null
          );
        });

        if (gettoLatLong.length > 0 && getfromLatLong.length > 0) {
          new_data = {
            fromlocationId: this.salesList.fromlocationId,
            tolocationId: this.salesList.tolocationId,
            stuffinglocationId: this.salesList.stuffinglocationId,
            fromlatitude: getfromLatLong[0].latitude,
            fromlongitude: getfromLatLong[0].longitude,
            tolatitude: gettoLatLong[0].latitude,
            tolongitude: gettoLatLong[0].longitude
          };
        } else if (this.salesList.stuffinglocationId != "") {
          new_data = {
            fromlocationId: this.salesList.fromlocationId,
            tolocationId: this.salesList.tolocationId,
            stuffinglocationId: this.salesList.stuffinglocationId,
            fromlatitude: "",
            fromlongitude: "",
            tolatitude: "",
            tolongitude: ""
          };

          this.salesList.distance = "";
        } else {
          new_data = "";
          this.salesList.distance = "";
          this.salesList.tollPrice = "";
          return false;
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/getDistanceToll.php`,
          data: JSON.stringify(new_data),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.salesList.distance = data.distancegps;
              this.salesList.tollPrice = data.tollCost;
            }
          })
          .catch(error => {});
      }
    },
    getClientList() {
      let new_data = {
        allView: "ClientList"
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewClientList.php`,
        data: JSON.stringify(new_data),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.getLocationData = data.locationMaster;

            this.$store.dispatch("setLocationList", data.locationMaster);
            this.salesList.dieselRate = data.dieselRate;
            if (
              this.$sessionsStorage.get("setEnquiryBookingId") != undefined &&
              this.$sessionsStorage.get("setEnquiryBookingId") != ""
            ) {
              this.viewEnquiryDetail();
            }
          }
        })
        .catch(error => {});
    },
    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.salesList.driverExpense) *
        parseFloat(this.salesList.noOffDay);

      let averageTrucknew =
        parseFloat(this.salesList.distance) /
        parseFloat(this.salesList.truckAverage);

      let dieselRatenew =
        parseFloat(averageTrucknew) * parseFloat(this.salesList.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.salesList.tollPrice);
      this.salesList.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.salesList.baseCost) *
          parseFloat(this.salesList.quotemargin)) /
        100;
      let finalSalesCost2 =
        finalSalesCost + parseFloat(this.salesList.baseCost);
      this.salesList.quoteSalesCost = finalSalesCost2.toFixed(2);
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 5px;
}

.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.mx-input-icon__calendar {
  margin-top: 0px !important;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// leadsBooking.vue?84f3bf28